import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumeDataByID } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';

@Component({
  selector: 'app-compact-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './compact-template.component.html',
  styleUrl: './compact-template.component.scss'
})
export class CompactTemplateComponent {
  @Input() data!: ResumeDataByID;
  @Input() color: string = '#4f46e5';
  @Input() font: string = 'Inter'

}
